<template>
  <div class="progress-info-page-component">
    <h2>What’s Included in Overall Performance?</h2>
    <p>Your overall performance measures your progress based on how many <strong>Unique Practice Questions</strong> you’ve answered.</p>
    <div>
      <p>To improve your stats:</p>
      <ol>
        <li><p><strong>Percent Correct</strong> – retry any questions you tagged "Don't Know" or "Somewhat Know."</p></li>
        <li><p><strong>Unique Questions</strong> – answer any questions you haven’t attempted yet.</p></li>
      </ol>
    </div>
    <h2>What About Quizzes?</h2>
    <p>Because quizzes and custom quizzes are intended to provide you with an indication of your current readiness, the results are not included in your overall performance. Instead, you’ll receive performance details for each quiz individually upon completion.</p>
  </div>
</template>

<script>

export default {
};
</script>

<style lang="scss" scoped>
.progress-info-page-component {
  h2 {
    font-size: rem-calc(18);
    font-weight: $semi-bold;
    margin-bottom: 0;
  }
  p {
    font-size: rem-calc(16);
    line-height: rem-calc(24);
  }
  > div {
    p {
      margin: 0;
    }
    ol {
      margin-top: 0;
      padding-left: rem-calc(20);
    }
  }
}
</style>
